import React from 'react'

let CardHeader = ({children}) => <div className='card-header'>{children}</div>

export default CardHeader